function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "social-Medium",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f3f5f8",
    style: {
      fill: "var(--color1, #f3f5f8)"
    },
    d: "M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16c0-8.837-7.163-16-16-16s-16 7.163-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color2, #000)"
    },
    d: "M9.9 12.2c0-0.2-0.1-0.4-0.2-0.5l-1.5-1.8v-0.3h4.6l3.6 7.9 3.2-7.9h4.4v0.3l-1.3 1.2c-0.1 0.1-0.2 0.2-0.1 0.4v9c0 0.1 0 0.3 0.1 0.4l1.2 1.2v0.3h-6.3v-0.3l1.3-1.3c0.1-0.1 0.1-0.2 0.1-0.4v-7.3l-3.6 9.1h-0.4l-4.2-9.1v6.1c0 0.3 0.1 0.5 0.2 0.7l1.7 2v0.3h-4.7v-0.3l1.7-2c0.2-0.2 0.3-0.4 0.2-0.7v-7z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "social-Vimeo",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1ab7ea",
    style: {
      fill: "var(--color3, #1ab7ea)"
    },
    d: "M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16c0-8.837-7.163-16-16-16s-16 7.163-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M8 12.8l0.7 0.9c0 0 1.3-1.1 1.8-0.5 0.4 0.5 2.2 6.9 2.7 8.1 0.5 1 1.9 2.4 3.4 1.4s6.5-5.2 7.4-10.3c0.9-5-6-4-6.7 0.4 1.7-1.1 2.7 0.4 1.7 2.2-0.9 1.7-1.8 2.9-2.2 2.9s-0.8-1.2-1.3-3.2c-0.5-2.2-0.5-6-2.7-5.5-2.1 0.4-4.8 3.6-4.8 3.6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "social-Skype",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0078d7",
    style: {
      fill: "var(--color5, #0078d7)"
    },
    d: "M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16c0-8.837-7.163-16-16-16s-16 7.163-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M16 20.8c-2.7 0-3.9-1.4-3.9-2.4 0-0.2 0.1-0.5 0.3-0.6 0.2-0.2 0.4-0.2 0.6-0.2 1.1 0 0.8 1.7 3 1.7 1.1 0 1.7-0.7 1.7-1.3 0-0.4-0.2-0.8-0.9-1l-2.4-0.6c-1.9-0.5-2.2-1.6-2.2-2.5 0-2.1 1.9-2.8 3.7-2.8 1.6 0 3.6 0.9 3.6 2.1 0 0.5-0.4 0.8-1 0.8-1 0-0.8-1.4-2.8-1.4-1 0-1.5 0.5-1.5 1.1s0.8 0.9 1.4 1l1.8 0.4c1.9 0.4 2.4 1.6 2.4 2.6 0 1.9-1.3 3.1-3.8 3.1zM23.4 17.3c0.1-0.4 0.1-0.9 0.1-1.3 0-2.2-1-4.3-2.7-5.8s-4-2-6.2-1.7c-0.6-0.3-1.4-0.5-2.2-0.5-1.6 0-3.1 0.9-3.9 2.3s-0.8 3.1 0 4.5c-0.4 2.4 0.3 4.9 2.1 6.7 1.7 1.7 4.2 2.5 6.6 2.1 0.7 0.4 1.4 0.6 2.2 0.6 1.6 0 3.1-0.9 3.9-2.3 0.8-1.5 0.9-3.2 0.1-4.6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "social-Twitter",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1da1f2",
    style: {
      fill: "var(--color6, #1da1f2)"
    },
    d: "M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16c0-8.837-7.163-16-16-16s-16 7.163-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M24 11c-0.6 0.3-1.2 0.4-1.9 0.5 0.7-0.4 1.2-1 1.4-1.8-0.6 0.4-1.3 0.6-2.1 0.8-0.6-0.6-1.5-1-2.4-1-2.1 0-3.7 2-3.2 4-2.7-0.1-5.1-1.4-6.8-3.4-0.9 1.5-0.4 3.4 1 4.4-0.5 0-1-0.2-1.5-0.4 0 1.5 1.1 2.9 2.6 3.3-0.5 0.1-1 0.2-1.5 0.1 0.4 1.3 1.6 2.3 3.1 2.3-1.2 0.9-3 1.4-4.7 1.2 1.5 0.9 3.2 1.5 5 1.5 6.1 0 9.5-5.1 9.3-9.8 0.7-0.4 1.3-1 1.7-1.7z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "social-YouTube",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f00",
    style: {
      fill: "var(--color7, #f00)"
    },
    d: "M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16c0-8.837-7.163-16-16-16s-16 7.163-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M23.6 12.1c-0.2-0.7-0.7-1.2-1.4-1.4-1.2-0.3-6.3-0.3-6.3-0.3s-5 0-6.3 0.3c-0.7 0.2-1.2 0.7-1.4 1.4-0.2 1.3-0.2 3.9-0.2 3.9s0 2.6 0.3 3.9c0.2 0.7 0.7 1.2 1.4 1.4 1.2 0.3 6.3 0.3 6.3 0.3s5 0 6.3-0.3c0.7-0.2 1.2-0.7 1.4-1.4 0.3-1.3 0.3-3.9 0.3-3.9s0-2.6-0.4-3.9zM14.4 18.4v-4.8l4.2 2.4-4.2 2.4z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "social-LinkedIn",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2867b2",
    style: {
      fill: "var(--color8, #2867b2)"
    },
    d: "M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16c0-8.837-7.163-16-16-16s-16 7.163-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M11.6 24h-3.4v-10.7h3.4v10.7zM9.9 11.8c-1.1 0-1.9-0.8-1.9-1.9s0.9-1.9 1.9-1.9c1.1 0 1.9 0.8 1.9 1.9s-0.8 1.9-1.9 1.9zM24 24h-3.4v-5.8c0-1.7-0.7-2.2-1.7-2.2s-2 0.8-2 2.3v5.7h-3.4v-10.7h3.2v1.5c0.3-0.7 1.5-1.8 3.2-1.8 1.9 0 3.9 1.1 3.9 4.4v6.6h0.2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "social-Facebook",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1877f2",
    style: {
      fill: "var(--color9, #1877f2)"
    },
    d: "M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16c0-8.837-7.163-16-16-16s-16 7.163-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M24 16c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 4 2.9 7.3 6.7 7.9v-5.6h-2v-2.3h2v-1.8c0-2 1.2-3.1 3-3.1 0.9 0 1.8 0.2 1.8 0.2v2h-1c-1 0-1.3 0.6-1.3 1.2v1.5h2.2l-0.4 2.3h-1.9v5.7c4-0.6 6.9-4 6.9-8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "social-Signal",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3a76f0",
    style: {
      fill: "var(--color10, #3a76f0)"
    },
    d: "M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16c0-8.837-7.163-16-16-16s-16 7.163-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M14.079 8.234l0.18 0.727c-0.708 0.175-1.385 0.455-2.009 0.832l-0.384-0.643c0.687-0.416 1.434-0.725 2.214-0.916zM17.921 8.234l-0.18 0.727c0.708 0.175 1.385 0.455 2.009 0.832l0.389-0.643c-0.689-0.416-1.437-0.725-2.218-0.916zM9.15 11.863c-0.416 0.688-0.725 1.435-0.916 2.216l0.727 0.18c0.175-0.708 0.455-1.385 0.832-2.009l-0.643-0.386zM8.75 16c-0-0.364 0.027-0.727 0.082-1.086l-0.741-0.114c-0.12 0.795-0.12 1.603 0 2.398l0.741-0.111c-0.054-0.36-0.082-0.723-0.082-1.086zM20.134 22.848l-0.384-0.641c-0.623 0.377-1.3 0.657-2.007 0.832l0.18 0.727c0.779-0.193 1.525-0.502 2.212-0.918zM23.25 16c0 0.364-0.027 0.727-0.082 1.086l0.741 0.111c0.12-0.795 0.12-1.603 0-2.398l-0.741 0.114c0.055 0.36 0.082 0.723 0.082 1.086zM23.766 17.918l-0.727-0.18c-0.174 0.709-0.455 1.387-0.832 2.012l0.643 0.386c0.416-0.689 0.725-1.437 0.916-2.218zM17.086 23.169c-0.72 0.109-1.453 0.109-2.173 0l-0.111 0.741c0.794 0.12 1.602 0.12 2.396 0l-0.111-0.741zM21.837 20.3c-0.432 0.586-0.95 1.103-1.536 1.534l0.445 0.605c0.646-0.476 1.217-1.045 1.696-1.689l-0.605-0.45zM20.3 10.163c0.586 0.432 1.104 0.95 1.536 1.536l0.605-0.45c-0.476-0.645-1.046-1.215-1.691-1.691l-0.45 0.605zM10.163 11.7c0.432-0.586 0.95-1.104 1.536-1.536l-0.45-0.605c-0.645 0.476-1.215 1.046-1.691 1.691l0.605 0.45zM22.85 11.863l-0.643 0.386c0.377 0.623 0.657 1.3 0.832 2.007l0.727-0.18c-0.192-0.78-0.5-1.526-0.916-2.214zM14.914 8.831c0.72-0.109 1.453-0.109 2.173 0l0.111-0.741c-0.794-0.12-1.602-0.12-2.396 0l0.111 0.741zM10.547 22.639l-1.548 0.359 0.361-1.548-0.73-0.17-0.361 1.548c-0.023 0.096-0.026 0.195-0.010 0.293s0.051 0.191 0.103 0.274c0.052 0.084 0.12 0.157 0.2 0.214s0.171 0.099 0.267 0.121c0.112 0.025 0.229 0.025 0.341 0l1.548-0.357-0.17-0.734zM8.786 20.612l0.732 0.168 0.25-1.073c-0.365-0.612-0.637-1.276-0.807-1.968l-0.727 0.18c0.164 0.663 0.411 1.302 0.736 1.902l-0.184 0.791zM12.286 22.235l-1.073 0.25 0.17 0.732 0.789-0.184c0.6 0.326 1.239 0.574 1.902 0.736l0.18-0.727c-0.69-0.172-1.351-0.446-1.962-0.811l-0.007 0.005zM16 9.5c-3.591 0.002-6.498 2.914-6.498 6.503 0.002 1.222 0.348 2.42 0.998 3.455l-0.625 2.668 2.666-0.625c3.039 1.912 7.053 1 8.964-2.037s1.002-7.050-2.034-8.964c-1.040-0.654-2.243-1-3.471-1z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "social-Telegram",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#08c",
    style: {
      fill: "var(--color11, #08c)"
    },
    d: "M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16c0-8.837-7.163-16-16-16s-16 7.163-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M8.1 15.708c4.295-1.871 7.159-3.105 8.592-3.701 4.092-1.702 4.942-1.997 5.496-2.007 0.122-0.002 0.394 0.028 0.571 0.171 0.149 0.121 0.19 0.284 0.21 0.399s0.044 0.376 0.025 0.58c-0.222 2.33-1.181 7.983-1.669 10.592-0.206 1.104-0.613 1.474-1.007 1.51-0.856 0.079-1.505-0.565-2.334-1.109-1.297-0.85-2.029-1.379-3.288-2.209-1.455-0.959-0.512-1.485 0.317-2.346 0.217-0.225 3.987-3.654 4.060-3.965 0.009-0.039 0.018-0.184-0.069-0.26s-0.213-0.050-0.305-0.030c-0.13 0.030-2.202 1.399-6.214 4.108-0.588 0.404-1.121 0.6-1.598 0.59-0.526-0.011-1.538-0.297-2.29-0.542-0.923-0.3-1.656-0.458-1.592-0.968 0.033-0.265 0.399-0.537 1.096-0.814z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "social-Whatsapp",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#25d366",
    style: {
      fill: "var(--color12, #25d366)"
    },
    d: "M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16c0-8.837-7.163-16-16-16s-16 7.163-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M21.6 10.3c-1.5-1.5-3.5-2.3-5.6-2.3-4.4 0-8 3.6-8 8 0 1.4 0.4 2.8 1.1 4l-1.1 4 4.2-1.1c1.2 0.6 2.5 1 3.8 1 4.4 0 8-3.6 8-8 0-2.1-0.9-4.1-2.4-5.6zM16 22.6c-1.2 0-2.4-0.3-3.4-0.9l-0.2-0.1-2.5 0.7 0.7-2.4-0.2-0.3c-0.7-1.1-1-2.3-1-3.5 0-3.6 3-6.6 6.6-6.6 1.8 0 3.4 0.7 4.7 1.9 1.3 1.3 1.9 2.9 1.9 4.7 0 3.5-2.9 6.5-6.6 6.5zM19.6 17.6c-0.2-0.1-1.2-0.6-1.4-0.6-0.2-0.1-0.3-0.1-0.4 0.1s-0.5 0.6-0.6 0.8c-0.1 0.1-0.2 0.1-0.4 0.1-0.2-0.1-0.8-0.3-1.6-1-0.6-0.5-1-1.2-1.1-1.4s0-0.3 0.1-0.4c0.1-0.1 0.2-0.2 0.3-0.3s0.1-0.2 0.2-0.3c0.1-0.1 0-0.2 0-0.3s-0.4-1.1-0.6-1.5c-0.1-0.3-0.3-0.3-0.4-0.3s-0.2 0-0.4 0c-0.1 0-0.3 0-0.5 0.2s-0.7 0.7-0.7 1.7c0 1 0.7 1.9 0.8 2.1 0.1 0.1 1.4 2.2 3.4 3 1.7 0.7 2 0.5 2.4 0.5s1.2-0.5 1.3-0.9c0.2-0.5 0.2-0.9 0.1-0.9-0.1-0.5-0.3-0.5-0.5-0.6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "social-Instagram",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f00073",
    style: {
      fill: "var(--color13, #f00073)"
    },
    d: "M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16c0-8.837-7.163-16-16-16s-16 7.163-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M16 9.2c2.2 0 2.5 0 3.4 0 0.8 0 1.2 0.2 1.5 0.3 0.4 0.2 0.7 0.3 1 0.6s0.5 0.6 0.6 1c0.1 0.3 0.2 0.7 0.3 1.5 0 0.9 0 1.1 0 3.4s0 2.5 0 3.4c0 0.8-0.2 1.2-0.3 1.5-0.2 0.4-0.3 0.7-0.6 1s-0.6 0.5-1 0.6c-0.3 0.1-0.7 0.2-1.5 0.3-0.9 0-1.1 0-3.4 0s-2.5 0-3.4 0c-0.8 0-1.2-0.2-1.5-0.3-0.4-0.2-0.7-0.3-1-0.6s-0.5-0.6-0.6-1c-0.1-0.3-0.2-0.7-0.3-1.5 0-0.9 0-1.1 0-3.4s0-2.5 0-3.4c0-0.8 0.2-1.2 0.3-1.5 0.2-0.4 0.3-0.7 0.6-1s0.6-0.5 1-0.6c0.3-0.1 0.7-0.2 1.5-0.3 0.9 0 1.2 0 3.4 0zM16 7.7c-2.3 0-2.5 0-3.4 0s-1.5 0.2-2 0.4c-0.5 0.2-1 0.5-1.5 1s-0.7 0.9-1 1.5c-0.2 0.5-0.3 1.1-0.4 2 0 0.9 0 1.2 0 3.4 0 2.3 0 2.5 0 3.4s0.2 1.5 0.4 2c0.2 0.5 0.5 1 1 1.5s0.9 0.7 1.5 1c0.5 0.2 1.1 0.3 2 0.4 0.9 0 1.2 0 3.4 0s2.5 0 3.4 0c0.9 0 1.5-0.2 2-0.4s1-0.5 1.5-1c0.5-0.5 0.7-0.9 1-1.5 0.2-0.5 0.3-1.1 0.4-2 0-0.9 0-1.2 0-3.4s0-2.5 0-3.4c0-0.9-0.2-1.5-0.4-2s-0.5-1-1-1.5c-0.5-0.5-0.9-0.7-1.5-1-0.5-0.2-1.1-0.3-2-0.4-0.9 0-1.1 0-3.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M16 11.7c-2.4 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3c2.4 0 4.3-1.9 4.3-4.3s-1.9-4.3-4.3-4.3zM16 18.8c-1.5 0-2.8-1.2-2.8-2.8 0-1.5 1.2-2.8 2.8-2.8 1.5 0 2.8 1.2 2.8 2.8 0 1.5-1.3 2.8-2.8 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M20.4 12.6c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1s0.448 1 1 1z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "social-Pinterest",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e60023",
    style: {
      fill: "var(--color14, #e60023)"
    },
    d: "M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16c0-8.837-7.163-16-16-16s-16 7.163-16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color4, #fff)"
    },
    d: "M16 8c-4.4 0-8 3.6-8 8 0 3.3 2 6.1 4.8 7.3 0-0.6 0-1.2 0.1-1.8 0.2-0.7 1-4.4 1-4.4s-0.3-0.5-0.3-1.3c0-1.2 0.7-2.1 1.5-2.1 0.7 0 1.1 0.5 1.1 1.2s-0.5 1.8-0.7 2.8c-0.2 0.8 0.4 1.5 1.3 1.5 1.5 0 2.5-1.9 2.5-4.3 0-1.8-1.2-3.1-3.3-3.1-2.4 0-3.9 1.8-3.9 3.8 0 0.7 0.2 1.2 0.5 1.6 0.1 0.2 0.2 0.2 0.1 0.4 0 0.1-0.1 0.5-0.2 0.6-0.1 0.2-0.2 0.3-0.4 0.2-1.1-0.5-1.6-1.7-1.6-3.1 0-2.3 1.9-5 5.7-5 3.1 0 5.1 2.2 5.1 4.6 0 3.1-1.7 5.5-4.3 5.5-0.9 0-1.7-0.5-2-1 0 0-0.5 1.8-0.6 2.2-0.2 0.6-0.5 1.2-0.8 1.7 0.7 0.2 1.5 0.3 2.3 0.3 4.4 0 8-3.6 8-8 0.1-4-3.5-7.6-7.9-7.6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "social-Google",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    style: {
      fill: "var(--color1, #4285f4)"
    },
    d: "M31.359 16.364c0-1.134-0.102-2.225-0.291-3.273h-15.068v6.189h8.61c-0.371 2-1.498 3.694-3.192 4.829v4.014h5.171c3.025-2.785 4.771-6.887 4.771-11.759z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    style: {
      fill: "var(--color2, #34a853)"
    },
    d: "M16 31.999c4.32 0 7.941-1.433 10.588-3.876l-5.171-4.014c-1.433 0.96-3.265 1.527-5.418 1.527-4.167 0-7.694-2.814-8.952-6.596h-5.345v4.145c2.632 5.229 8.043 8.814 14.297 8.814z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    style: {
      fill: "var(--color3, #fbbc05)"
    },
    d: "M7.048 19.040c-0.32-0.96-0.502-1.985-0.502-3.040s0.182-2.080 0.502-3.040v-4.145h-5.345c-1.084 2.16-1.702 4.603-1.702 7.185s0.618 5.025 1.702 7.185l5.345-4.145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    style: {
      fill: "var(--color4, #ea4335)"
    },
    d: "M16 6.364c2.349 0 4.458 0.807 6.116 2.392l4.589-4.589c-2.771-2.582-6.392-4.167-10.705-4.167-6.254 0-11.665 3.585-14.297 8.814l5.345 4.145c1.258-3.782 4.785-6.596 8.952-6.596z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "social-Microsoft",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f25022",
    style: {
      fill: "var(--color5, #f25022)"
    },
    d: "M0.001 0.001h15.157v15.157h-15.157v-15.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a4ef",
    style: {
      fill: "var(--color6, #00a4ef)"
    },
    d: "M0.001 16.842h15.157v15.157h-15.157v-15.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7fba00",
    style: {
      fill: "var(--color7, #7fba00)"
    },
    d: "M16.842 0.001h15.157v15.157h-15.157v-15.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb900",
    style: {
      fill: "var(--color8, #ffb900)"
    },
    d: "M16.842 16.842h15.157v15.157h-15.157v-15.157z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "social-QRCode",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e2effe",
    style: {
      fill: "var(--color1, #e2effe)"
    },
    d: "M32 16c0-8.837-7.163-16-16-16s-16 7.163-16 16c0 8.837 7.163 16 16 16s16-7.163 16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M12.533 13.4h-3.467c-0.478 0-0.867-0.388-0.867-0.867v-3.467c0-0.478 0.388-0.867 0.867-0.867h3.467c0.478 0 0.867 0.388 0.867 0.867v3.467c0 0.478-0.388 0.867-0.867 0.867z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M12.533 23.8h-3.467c-0.478 0-0.867-0.388-0.867-0.867v-3.467c0-0.478 0.388-0.867 0.867-0.867h3.467c0.478 0 0.867 0.388 0.867 0.867v3.467c0 0.478-0.388 0.867-0.867 0.867z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M22.933 13.4h-3.467c-0.478 0-0.867-0.388-0.867-0.867v-3.467c0-0.478 0.388-0.867 0.867-0.867h3.467c0.478 0 0.867 0.388 0.867 0.867v3.467c0 0.478-0.388 0.867-0.867 0.867z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M11.667 16h1.733"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M16 9.933v-1.733"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M19.467 16h-2.6c-0.478 0-0.867-0.388-0.867-0.867v-1.733"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M9.067 16h-0.867"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M18.6 21.2h-1.733c-0.478 0-0.867 0.388-0.867 0.867v1.733"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M16 18.6h5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M23.8 18.6v4.333c0 0.478-0.388 0.867-0.867 0.867h-4.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M10.8 10.791c-0.003 0-0.004 0.002-0.004 0.004s0.002 0.004 0.004 0.004c0.003 0 0.004-0.002 0.004-0.004s-0.002-0.004-0.004-0.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M21.196 10.796c-0.003 0-0.004 0.002-0.004 0.004s0.002 0.004 0.004 0.004c0.003 0 0.004-0.002 0.004-0.004s-0.002-0.004-0.004-0.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M22.062 15.996c-0.003 0-0.004 0.002-0.004 0.004s0.002 0.004 0.004 0.004c0.003 0 0.004-0.002 0.004-0.004s-0.002-0.004-0.004-0.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M21.196 21.196c-0.003 0-0.004 0.002-0.004 0.004s0.002 0.004 0.004 0.004c0.003 0 0.004-0.002 0.004-0.004s-0.002-0.004-0.004-0.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3699fe",
    strokeWidth: 1.2,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--color2, #3699fe)"
    },
    d: "M10.804 21.196c-0.003 0-0.004 0.002-0.004 0.004s0.002 0.004 0.004 0.004c0.003 0 0.004-0.002 0.004-0.004s-0.002-0.004-0.004-0.004z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.b1a40a9e7b47062d0e1650c6a9481457.svg";
export { ForwardRef as ReactComponent };